import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Container } from '@mui/material';

const SupportPage: React.FC = () => {
  const { t } = useTranslation('support');

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('pageTitle')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('pageDescription')}
        </Typography>
      </Box>
    </Container>
  );
};

export default SupportPage;
